export const AnnouncementBar = () => (
  <div
    data-testid="announcement-bar"
    className="flex items-center justify-center gap-3 bg-brand-charcoal px-4 py-2.5 text-center"
  >
    <span className="hidden h-px w-6 bg-brand-gold-light/60 sm:block" aria-hidden="true" />
    <p className="text-[11px] font-medium uppercase tracking-[0.22em] text-brand-gold-light">
      Complimentary shipping across India · Handcrafted in small batches
    </p>
    <span className="hidden h-px w-6 bg-brand-gold-light/60 sm:block" aria-hidden="true" />
  </div>
);
